import { render, staticRenderFns } from "./ActiveOtherLoans.vue?vue&type=template&id=444dfcf6"
import script from "./ActiveOtherLoans.vue?vue&type=script&lang=js"
export * from "./ActiveOtherLoans.vue?vue&type=script&lang=js"
import style0 from "./ActiveOtherLoans.vue?vue&type=style&index=0&id=444dfcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports